module.exports = __webpack_public_path__ + "cancellara-dist/img/motivation-network.fcd09a0c.png";